import { api } from '../lib/api'
import type { InvestigationStatus, ManagerOutcome } from '../lib/types'

export interface OpenManagerAnalysis {
  id: string
  title: string
  hypothesis: string
  status: InvestigationStatus
  reportId: string
  weekStart: string
  clientId: string
  clientName: string
  managerId: string
  managerName: string
}

export const investigationsApi = {
  open: () => api.get<{ analyses: OpenManagerAnalysis[] }>('/investigations/open'),
  // Resultado em 1 clique + comentário opcional.
  submitFindings: (id: string, outcome: ManagerOutcome, note?: string) =>
    api.post<{ status: string; message: string }>(`/investigations/${id}/findings`, {
      outcome,
      managerFindings: note?.trim() || undefined,
    }),
  // Refaz a investigação da IA que falhou.
  retry: (id: string) => api.post<{ status: string }>(`/investigations/${id}/retry`, {}),
}
